import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';

import { RouterStateUrl } from '../../models';

export const getRouterState = createFeatureSelector<fromRouter.RouterReducerState<RouterStateUrl>>(
  'router',
);

export const getUrl = createSelector(getRouterState, (resp) => resp.state.url);

export const getQueryParams = createSelector(getRouterState, (resp) => (
  resp && resp.state && resp.state.queryParams
) || null);

export const getParams = createSelector(getRouterState, (resp) => resp.state.params);
